import { myWalletClickHelper, sanitizeValue } from './helpers/index.js';

/**
 * @summary Sends Pixall Click event on Sync Button Click
 */
export async function walletManualImportBtnClick(metadata, option) {
  if (option === void 0) {
    option = {};
  }
  const {
    useCDL = false
  } = option;
  const {
    data = {},
    dataLayer
  } = metadata;
  const {
    label = ''
  } = data;
  const eventResult = `cta::confirm-manual::import-settings${metadata?.data?.isNew ? '::first-use' : ''}`;
  const textContent = sanitizeValue(label);
  myWalletClickHelper({
    withPixallData: true,
    dataLayer,
    pixallLabel: 'cta::sync-now:my-wallet',
    pixallData: {
      cdl: useCDL ? {
        eventProperties: {
          event: {
            action: 'Click',
            element: 'Sync Now with ID Button',
            intention: 'Sync Your Shopping Complete',
            location: 'Sync Your Shopping Modal',
            elementText: textContent
          }
        }
      } : undefined
    }
  }, option);
  return {
    eventResult
  };
}

/**
 * @summary Sends PixAll Click event on Import settings link click
 */
export async function walletImportSettingsClick(metadata, option) {
  const {
    useCDL = false
  } = option;
  const {
    dataLayer = {},
    data = {}
  } = metadata;
  const {
    isLastSync = false
  } = data;
  const eventResult = isLastSync ? 'text-link::last-sync' : 'text-link::import-settings';
  myWalletClickHelper({
    dataLayer,
    withPixallData: true,
    pixallLabel: eventResult,
    pixallData: {
      cdl: useCDL ? {
        eventProperties: {
          event: {
            action: 'Click',
            element: isLastSync ? 'Last Sync Date Link' : 'Import Settings Button'
          }
        }
      } : undefined
    }
  }, option);
  return {
    eventResult
  };
}

/**
 * @summary Sends Pixall Click event on automatic sync
 */
export async function walletAutoSyncSuccess(metadata, option) {
  const {
    dataLayer = {}
  } = metadata;
  const eventResult = 'text-link::automatic::import-settings';
  myWalletClickHelper({
    dataLayer,
    withPixallData: true,
    pixallLabel: eventResult
  }, option);
  return {
    eventResult
  };
}

/**
 * @summary Sends Pixall Click event on Email Sync click
 */
export async function walletEmailSyncBtnClick(metadata, option) {
  if (option === void 0) {
    option = {};
  }
  const {
    useCDL = false
  } = option;
  const {
    data = {},
    dataLayer
  } = metadata;
  const {
    label = ''
  } = data;
  const textContent = sanitizeValue(label);
  const eventResult = 'cta::sync-now_email::my-wallet';
  myWalletClickHelper({
    dataLayer,
    withPixallData: true,
    pixallLabel: eventResult,
    pixallData: {
      cdl: useCDL ? {
        eventProperties: {
          event: {
            element: 'Sync Now With Email Button',
            action: 'Click',
            intention: 'Sync Your Shopping Complete',
            location: 'Sync Your Shopping Modal',
            elementText: textContent
          }
        }
      } : undefined
    }
  }, option);
  return {
    eventResult
  };
}

/**
 * @summary Sends Pixall Click event on footer click
 */
export async function walletIdSyncFooterClick(metadata, option) {
  const {
    dataLayer = {}
  } = metadata;
  const {
    useCDL = false
  } = option;
  const eventResult = 'text-link::where-is-my-wallet-id';
  myWalletClickHelper({
    dataLayer,
    withPixallData: true,
    pixallLabel: eventResult,
    pixallData: {
      cdl: useCDL ? {
        eventProperties: {
          event: {
            action: 'Click',
            element: 'Where is My Wallet ID Link'
          }
        }
      } : undefined
    }
  }, option);
  return {
    eventResult
  };
}
export default {
  walletManualImportBtnClick,
  walletImportSettingsClick,
  walletAutoSyncSuccess,
  walletEmailSyncBtnClick,
  walletIdSyncFooterClick
};